import { FmlxCard } from "fmlx-common-ui";
import FmlxSkeleton from "../Skeleton/FmlxSkeleton";

const SkeletonCard = ({data}) => {
  const {heading, dataFormated, actions} =data;

  return (
  <FmlxCard>
    <FmlxCard.Body className="skeleton" variant={FmlxCard.Variant.OUTLINED}>
      {heading !== null && (
        <FmlxSkeleton
          className="mx-auto mb-2"
          width={120}
          height={24}
          variant={FmlxSkeleton.Variant.TEXT}
          animation={FmlxSkeleton.Animation.WAVE}
        />
      )}

      {dataFormated !== null && (
        <FmlxSkeleton
          className="mx-auto mb-2"
          width={160}
          height={32}
          variant={FmlxSkeleton.Variant.TEXT}
          animation={FmlxSkeleton.Animation.WAVE}
        />
      )}

      {actions?.length > 0 && (
        <div className="mt-4 flex justify-center gap-2 flex-wrap">
          {actions.map((_, index) => (
            <FmlxSkeleton
              key={index}
              width={96}
              height={36}
              variant={FmlxSkeleton.Variant.RECTANGULAR}
              animation={FmlxSkeleton.Animation.WAVE}
              className="rounded"
            />
          ))}
        </div>
      )}
    </FmlxCard.Body>
  </FmlxCard>
)}

export default SkeletonCard;